import { defineStore } from 'pinia';
import useStore from '@/store';
import { ref } from 'vue';
import { UserScore, UserStats } from '@/entities/leaderboard';

export default defineStore('leaderboard', () => {
  const rootStore = useStore();
  const userStats = ref<UserStats>();
  const userScores = ref<UserScore[]>([]);
  const currentPage = ref(1);
  const pageSize = ref(10);
  const totalPages = ref<number>(0);
  const isLoading = ref(false);

  return {
    userScores,
    totalPages,
    currentPage,
    userStats,
    isLoading,
    defaultImage: 'https://cpcontents.adobe.com/public/images/default_user_avatar.svg',

    async init() {
      void this.getUserStats();
    },
    async getUserScores(page: number = 1) {
      currentPage.value = page;
      isLoading.value = true;

      const { data, pageCount } = await rootStore.apiService.leaderboard.fetchUserScores(
        currentPage.value,
        pageSize.value
      );
      userScores.value = data.map((userScore) => new UserScore(userScore));
      totalPages.value = pageCount;

      const imagesData = await rootStore.apiService.leaderboard.fetchUserAvatars(
        userScores.value.map((user) => user.id)
      );

      userScores.value.forEach((userScore) => {
        const image = imagesData.find((image) => String(image.id) === userScore.id);
        if (image) {
          userScore.imageUrl = `${rootStore.appBaseDomain}${image.imageUrl}`;
        } else {
          userScore.imageUrl = this.defaultImage;
        }
      });

      isLoading.value = false;
    },
    async getUserStats() {
      isLoading.value = true;
      const statsData = await rootStore.apiService.leaderboard.fetchUserStats();
      userStats.value = new UserStats(statsData);

      const { coursesCompleted, programsCompleted } =
        await rootStore.primeService.learningObject.fetchCompletedLearningObjectsCount();

      userStats.value.masteredTotal = {
        courses: coursesCompleted,
        programs: programsCompleted
      };

      const lastCompleted = await rootStore.primeService.learningObject.fetchLastCompletedCourse();
      if (lastCompleted.data.length > 0 && lastCompleted.data[0].enrollment) {
        userStats.value.lastCompleted = lastCompleted.data[0].enrollment.dateCompleted;
      } else {
        userStats.value.lastCompleted = '';
      }

      isLoading.value = false;
    }
  };
});
